import { Component, OnInit } from '@angular/core';
import {LoginService} from '../../login-service';
import Swal from 'sweetalert2';

declare var paypal:any;
import {render} from 'creditcardpayments/creditCardPayments';
import { Router } from '@angular/router';
import { StripeService, Elements, Element as StripeElement, ElementsOptions } from "ngx-stripe";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Http} from '@angular/http';
@Component({
    selector: 'pay-app',
    templateUrl: 'pay.component.html',
    styleUrls: ['./cost.component.scss']
})

export class PayComponent implements OnInit {
    viewDetails: boolean=false;
    displayInvoice: boolean=false;
    usersList: any;
    invoiceList: any;
    userTypeName: string;
    userID: string;
    collaboList: any;
    filteredcollaboList: any=[];
    currentcollabo: any;
    viewCollaborators: boolean=false;
    tempProposalBids: any;
    collaboBids: any=[];
    actorsList: any;
    actors: any=[];
    biduser: any;
    tempuser=[];
    url:string;
    collaboname: any;
    invoices: any;
    userinfo: any;
    invoicedetails: any;
    totalamount: number;
    approved:boolean=false;
    paid:boolean=false;
    invoicePayments=[];
    elements: Elements;
    card: StripeElement;
    stripeTest:FormGroup;
    elementsOptions: ElementsOptions = {
        locale: 'es'
      };
    payvalue: any;
    paystripe: boolean=false;
  paymentsList: any;
  skillsList: any;
  filteredskillsList: any;
  skillsList2: any;
  filteredskillsList2: any=[];
  filteredSkillsnameList: any=[];
  collaboamount: any=[];
  colamount: any;
  collabo_paytype: any;
  c: any;
  expandedIndex = 0;
  presentCollabos: any;
  searchText: any;
  tempcollabos: any;
  paidamount: any;
  Accordian: any;
  tempinvoices: any=[];
  invoiceactors:any=[];
  collaboratorsamount: any;
  collbtorsamount: any=[];
  showbuttons:boolean=false;
  private isCollapsed: boolean = true;
    constructor (private loginService:LoginService,private http : Http,
        private fb: FormBuilder,
        private stripeService: StripeService,private router:Router) {
        this.userID=localStorage.getItem('USERID');
        this.userTypeName=localStorage.getItem('userType');
    }

    ngOnInit() {
        this.GetUsers();
        this.GetInvoices();
        this.GetCollabos();
        this.stripeTest = this.fb.group({
            name: ['', [Validators.required]]
          });
          this.stripeService.elements(this.elementsOptions)
            .subscribe(elements => {
              this.elements = elements;
              // Only mount the element the first time
              if (!this.card) {
                this.card = this.elements.create('card', {
                  style: {
                    base: {
                      iconColor: '#666EE8',
                      color: '#31325F',
                      lineHeight: '40px',
                      fontWeight: 300,
                      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                      fontSize: '18px',
                      '::placeholder': {
                        color: '#CFD7E0'
                      }
                    }
                  }
                });
                this.card.mount('#card-element');
              }
            });
    }
    opencollabo(item){
      this.c=item;
     
    }
    GetUsers(){
        this.loginService.GetUsers(this.userTypeName).subscribe(data=>
          {

            data = JSON.parse(data['_body']);
                  this.usersList=JSON.parse(JSON.stringify(data));
                 
          })
        }

        GetInvoices(){
            this.loginService.GetInvoices().subscribe(data=>
              {
                data = JSON.parse(data['_body']);
                      this.invoiceList=JSON.parse(JSON.stringify(data));
                    
              })
              this.loginService.GetInvoicePayments().subscribe(data=>
                {
                  data = JSON.parse(data['_body']);
                        this.paymentsList=JSON.parse(JSON.stringify(data));
                     
                })
            }

        GetCollabos(){
            this.loginService.GetCollabos(this.userTypeName).subscribe(data=>
                {
                  data = JSON.parse(data['_body']);
                        this.collaboList=JSON.parse(JSON.stringify(data));
                       
                        this.GetInvoices();
                        for(var i=0;i<this.invoiceList.length;i++){
                            let filterInvoices=this.collaboList.filter(x=>x.id==this.invoiceList[i].collaboid && x.userid==this.userID);
                            if(filterInvoices.length>0){
                                this.filteredcollaboList.push(filterInvoices);
                            }
                   else{
                    //    this.filteredcollaboList=[];
                   }
                        console.log(this.filteredcollaboList)
                      
                        var filterArray = this.filteredcollaboList.reduce((accumalator, current) => {
                          if(!accumalator.some(item => item[0].id === current[0].id )) {
                            accumalator.push(current);
                          }
                          return accumalator;
                      },[]);
                      console.log(filterArray)
                      this.filteredcollaboList=filterArray;
                        }
                       
                        this.loginService.GetPraposalBids().subscribe(data=>
                            {
                                data = JSON.parse(data['_body']);
                                this.tempProposalBids=JSON.parse(JSON.stringify(data));
                              
                           
                            for(var i=0;i<this.filteredcollaboList.length;i++){
                             
                              var bids=this.tempProposalBids.filter(x=>x.collaboid===this.filteredcollaboList[i][0].id && x.bidstatus== "Accepted")
                             console.log(bids)
                              var amount=0;
                              for(var j=0;j<bids.length;j++){
                                amount=amount+bids[j].amount;
                              }
                              this.collaboamount.push(amount);
                              console.log(this.collaboamount)
                              if(bids.length>0){
                            this.collaboBids.push(bids)
                              }
                        }
                        console.log(this.filteredcollaboList)
                      })
                      this.c=this.filteredcollaboList[0];
                      this.presentCollabos=this.filteredcollaboList;
                     console.log(this.filteredcollaboList)
                })
              }
              Searchtext(){
                this.filteredcollaboList=[];
                this.filteredcollaboList=this.presentCollabos;
              
                this.tempcollabos = this.filteredcollaboList;
            
                 let tempCompany = this.filteredcollaboList.filter(
                   (item) => {
                     return (
                       (item[0].title !== null && item[0].title.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
                     );
                   }
                
                 );
                 this.filteredcollaboList = tempCompany;
                
              }
        GetProposalbids(){
            this.loginService.GetPraposalBids().subscribe(data=>
                {
                    data = JSON.parse(data['_body']);
                    this.tempProposalBids=JSON.parse(JSON.stringify(data));

                })
        }
              calculateDiff(sentDate,enddate) {
                var date1:any = new Date(sentDate);
                var date2:any = new Date(enddate);
                var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));

                return diffDays;
            }

            paypalpay(data){
              this.showbuttons=true;
              this.payvalue=data;
              render({
                id:"#myPaypalButtons",
                currency:"USD",
                value:'20',
                onApprove:(details)=>{
          this.loginService.showSuccess("Transaction successful", 'success');
                  const json={
                      invoiceno:this.invoicedetails.id,
                      userid:this.userID,
                      usertype:'initiator',
                      paymenttype:'paypal',
                      status:'success',
                      paymenttoken:details.payer.payer_id,
                      payerid:details.payer.payer_id,
                      transactionid:details.id,
                      amount:this.payvalue,
                      response:details
                  }  
            
              this.loginService.SaveInvoicePayment(json).subscribe(data=>{
             
              this.PaidInvoice(this.invoicedetails);
              
              })
                  
                  this.router.navigateByUrl('/pay');
                  this.GetInvoices();
                  this.viewDetails=true;
                  this.displayInvoice=false;
                  this.viewCollaborators=false;
                }
              })
              
                
              }

              buyStripe() {
                const name = this.stripeTest.get('name').value;
              
                this.stripeService
                  .createToken(this.card, { name })
                  .subscribe(obj => {
                    if (obj) {
                      console.log("Token is --> ",obj.token.id);
              
              this.http.post("http://localhost:3000/payme",{
              token : obj.token.id,
              name:name,
              amount:this.payvalue*100
              }).subscribe(
              (res)=>{
          this.loginService.showSuccess("Transaction successful", 'success');
              const json={
                invoiceno:this.invoicedetails.id,
                userid:this.userID,
                usertype:'initiator',
                paymenttype:'stripe',
                status:'success',
                paymenttoken:obj.token.id,
                payerid:name,
                transactionid:obj.token.id,
                amount:this.payvalue,
                response:res
            }  
      
              this.loginService.SaveInvoicePayment(json).subscribe(data=>{
             
              this.PaidInvoice(this.invoicedetails);
              this.paystripe=false;
              })
              this.router.navigateByUrl('/pay');
              this.GetInvoices();
              this.viewDetails=true;
              this.displayInvoice=false;
              this.viewCollaborators=false;
              },
              (err)=>{
              console.log('The error is ',err)
              })
              
              
                    } else  {
                      // Error creating the token
                      console.log("Error comes ");
                    }
                  });
              }

              paywithStripe(){
                this.paystripe=true;
                console.log(this.paystripe)
              }
              Goback(){
                this.paystripe=false;
              }
    ViewCollaborators(c,amount){
       
        this.tempuser=[];
        this.collaboBids=[]; 
        this.GetProposalbids();
        console.log(this.invoiceList);
        var invoices=this.invoiceList.filter(x=>x.collaboid==c.id);
     console.log(invoices);
     console.log(this.tempProposalBids);
        for(var i=0;i<invoices.length;i++){
          var bids=this.tempProposalBids.filter(x=>x.userid==invoices[i].userid && x.collaboid==invoices[i].collaboid &&x.rowid==invoices[i].proposalbidrowid);
          console.log(bids);
         this.colamount=amount;
         if(bids.length>0){
        this.collaboBids.push(bids);
         }
        
        console.log(this.collaboBids);
        
          // if(this.collaboBids.indexof(bids)){

          // }
        }
       
        this.collaboname=c.title;
        this.collabo_paytype=c.pay_type;
        this.currentcollabo=c;
        this.viewCollaborators=true;
        this.displayInvoice=false;
        this.viewDetails=false;
        this.actors=[];
         this.loginService.GetCollaboActorDetails().subscribe(data=>
                {
                    data = JSON.parse(data['_body']);
                    this.actorsList=JSON.parse(JSON.stringify(data));
                    console.log(this.actorsList);
                    console.log(this.collaboBids);
                    for(var i=0;i<this.collaboBids.length;i++){
                      console.log(this.collaboBids[i])
                      var user;
                      this.collaboBids[i][0].actorids.split(',').forEach(element => {
                        console.log(element);
                      
                      var actor=this.actorsList.filter(x=>x.ActorId==element && x.CollaboId==this.collaboBids[i][0].collaboid)
                     console.log(actor);
                      if(actor.length>0){
                        this.actors.push(actor)
                      }
                       console.log(this.actors);
                        this.GetUsers();
                        
        this.biduser=this.usersList.filter(x=>x.id==this.collaboBids[i][0].userid);
    
        if(this.biduser.length>0){
       user=this.biduser[0];
       
        }
        if(user.Profile!==null){
             this.url="http://localhost:25396/";
            // this.url=this.loginService.imageURL;

            }
            else{
              this.url="";
              user.Profile='../../assets/images/user.png';

            }
           
            for(let j=0;j<this.actors.length;j++){
              if(this.actors[j]!==undefined){
                var actorname=this.actors[j].name;
                var actorid=this.actors[j].id;
              }
            }
            
          console.log(this.actors);
         
       
      });

      this.tempuser.push({
        username:user.user_name,
        profile:user.Profile,
        actr:this.actors,
        // actors:actorname,
        // actorid:actorid,
        rowid:this.collaboBids[i][0].rowid,
        amount:this.collaboBids[i][0].amount,
        collaboid:this.collaboBids[i][0].collaboid,
        servicecharge:this.collaboBids[i][0].servicecharge,
        totalhours:this.collaboBids[i][0].totalhours,
        userid:this.collaboBids[i][0].userid,
        description:this.collaboBids[i][0].description,
        collabostatus:this.collaboBids[i][0].collabostatus,
        hoursestimated:this.collaboBids[i][0].hoursestimated,
        paytype:c.pay_type,
    })
                    }
                    console.log(this.tempuser);
                    
                    var filterArray = this.tempuser.reduce((accumalator, current) => {
                      if(!accumalator.some(item => item.userid === current.userid )) {
                        accumalator.push(current);
                      }
                      return accumalator;
                  },[]);
                  console.log(filterArray)
                  this.tempuser=filterArray
                 
                 
                })

               
    }
    ViewCollaboDetails(c){
      this.collaboratorsamount=0;
      this.filteredSkillsnameList=[];
      this.filteredskillsList2=[];
      console.log(c)
        this.userinfo=this.tempProposalBids.filter(x=>x.userid==c.userid && x.collaboid==c.collaboid);
      console.log(this.userinfo);
        this.GetInvoices();
        this.invoices=this.invoiceList.filter(x=>x.userid==c.userid && x.collaboid==c.collaboid);
       console.log(this.invoices)
       this.invoiceactors=[];
       this.tempinvoices=[];
       var sum=0;
        for(var i=0;i<this.invoices.length;i++){
          this.invoiceactors=[];
 if(this.invoices[i].ispaid=='p'){
   
          var paidmoney=this.userinfo[i].amount;
          console.log(paidmoney)
          if(this.currentcollabo.pay_type=='hour')
          {
            sum+=paidmoney*this.userinfo[i].totalhours;
          }
          else{
            sum+=paidmoney;
          }
          }
          else{
            sum+=0;
          }
          console.log(sum)
          console.log(this.invoices[i].actorid)
          // this.invoices[i].actorid.split(',').forEach(element => {
          //   console.log(element);
          
          var actor=this.actorsList.filter(x=>x.ActorId==this.invoices[i].actorid && x.CollaboId==this.invoices[i].collaboid)
         console.log(actor);
         this.invoiceactors.push(actor)
          // })
          this.tempinvoices.push({
            actors: this.invoiceactors,
            address: this.invoices[i].address,
            city: this.invoices[i].city,
            collaboid: this.invoices[i].collaboid,
            companyname: this.invoices[i].companyname,
            country: this.invoices[i].country,
            createdby: this.invoices[i].createdby,
            createddate: this.invoices[i].createddate,
            emailaddress: this.invoices[i].emailaddress,
            id: this.invoices[i].id,
            invoicedate: this.invoices[i].invoicedate,
            invoiceno: this.invoices[i].invoiceno,
            isactive: this.invoices[i].isactive,
            isapproved: this.invoices[i].isapproved,
            ispaid:this.invoices[i].ispaid,
            phoneno: this.invoices[i].phoneno,
            proposalbidrowid:this.invoices[i].proposalbidrowid,
            state: this.invoices[i].state,
            updatedby:this.invoices[i].updatedby,
            updateddate: this.invoices[i].updateddate,
            userid: this.invoices[i].userid,
            zipcode: this.invoices[i].zipcode,
bidamount: this.userinfo[i].amount,
bidstatus: this.userinfo[i].bidstatus,
collabostatus: this.userinfo[i].collabostatus,
description: this.userinfo[i].description,
first_name: this.userinfo[i].first_name,
hoursestimated: this.userinfo[i].hoursestimated,
isactivebid: this.userinfo[i].isactive,
last_name: this.userinfo[i].last_name,
bidrowid: this.userinfo[i].rowid,
servicecharge: this.userinfo[i].servicecharge,
totalhours: this.userinfo[i].totalhours,
user_name: this.userinfo[i].user_name,
paytype:c.paytype,
          })
          this.collaboratorsamount=this.collaboratorsamount+this.userinfo[i].amount
        }
        this.paidamount=sum;
        console.log(this.paidamount)
        console.log(this.tempinvoices)
        this.viewDetails=true;
        this.displayInvoice=false;
        this.viewCollaborators=false;
       
        this.loginService.GetRegionSkills().subscribe(data=>
          {
            data = JSON.parse(data['_body']);
            this.skillsList =data;
           
            this.filteredskillsList=this.skillsList.filter(x=>x.userid.toString()===c.userid.toString());
           
            this.filteredskillsList[0].Skillid=JSON.parse(this.filteredskillsList[0].Skillid);
          
            this.loginService.Getskills(1).subscribe(data => {
              data = JSON.parse(data['_body']);
              this.skillsList2 =JSON.parse(JSON.stringify(data));
             
              for(let i=0;i<this.filteredskillsList[0].Skillid.length;i++)
              {
               
                var sid=this.skillsList2.filter(x=>x.id.toString()===this.filteredskillsList[0].Skillid[i].toString())
               
                if(sid.length>0){
                this.filteredskillsList2.push(sid);  
                }
              }
               
            for(var i=0;i<this.filteredskillsList2.length;i++){
              var sname=(this.filteredskillsList2[i][0]).skillname;
             
              this.filteredSkillsnameList.push(sname);
            }
            var AdditionalSkills=JSON.parse(this.filteredskillsList[0].AdditionalSkills);
            this.filteredSkillsnameList.push(AdditionalSkills)
          
            });
         });
    }
    ViewInvoice(i,userinfo){
      this.GetInvoices();
       console.log(i)
        this.invoicedetails=i;
        console.log(this.collabo_paytype)
        if(this.collabo_paytype=='hour'){
        this.totalamount=parseInt(this.invoicedetails.bidamount)*parseInt(this.invoicedetails.totalhours)
        }
        else{
          this.totalamount=this.invoicedetails.bidamount;
        }
        console.log(this.totalamount)
        this.displayInvoice=true;
        this.viewDetails=false;
        this.viewCollaborators=false;
    }
    ApproveInvoice(c,userinfo){
        
        const json={
            id:c.id
        } 
        this.loginService.ApproveInvoice(json).subscribe(data=>{

Swal.fire("Invoice Approved");
setTimeout(() => {
  this.GetInvoices();
}, 3000);
if(c.isapproved=='y'){
this.approved=true;
}
this.GetInvoices();
this. ViewInvoice(c,userinfo);
        })
    }
    PaidInvoice(c){
   
      const json={
          id:c.id
      } 
      this.loginService.PaidInvoice(json).subscribe(data=>{

// Swal.fire("Invoice Approved");
if(c.paid=='p'){
this.paid=true;
}
this.GetInvoices();
      })
  }
    backtoCollabos(){
        this.displayInvoice=false;
        this.viewDetails=false;
        this.viewCollaborators=false;
    }
    BacktoCollaborators(){
        this.viewCollaborators=true;
        this.displayInvoice=false;
        this.viewDetails=false;
    }
    BacktoCollaboDetails(){
        this.viewDetails=true;
        this.displayInvoice=false;
        this.viewCollaborators=false;
        this.showbuttons=false;
    }
    accordianValue(value)
    {
      this.Accordian=value;
    }
}
